/* src/app/settlement/view-settlement/view-settlement.component.css */
/*# sourceMappingURL=view-settlement.component-7KG6AS2O.css.map */
